import { call, put } from 'redux-saga/effects';

import { Set } from '~commonInfra/utils/Set';
import { SetDisplayTabsAction } from '~content/services/SetDisplayTabsAction';
import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { reloadSpaceIfUpdatingCurrentSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';
import { getWorkbookInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';
import { SetTabsWorkbookAction } from '~src/workbook/actions/SetTabsWorkbookAction';
import { IWorkbookInfo } from '~src/workbook/models/IWorkbookInfo';

export function* setTabsWorkbookSaga(action: SetTabsWorkbookAction) {
    const localizedErrorMessage = Messages.unexpectedError();
    try {
      const workbookInfos = yield getWorkbookInfos(action.workbooks);
      // errors are handled by the dialog - nothing to be done on success
      yield call(openSetTabsWorkbookDialog, workbookInfos);

      const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, action.workbooks);
      if (!maybeReloaded) {
        yield put(requestSpaceContents());
      }

    } catch(e) {
      yield put(requestFailed(e, localizedErrorMessage));
    }
  }

function openSetTabsWorkbookDialog(workbooks: IWorkbookInfo[]): Promise<any> {
    const workbooksSet = Set.fromIdItemArray(workbooks);
    return SetDisplayTabsAction.confirmSetDisplayTabs(workbooksSet);
  }
